import eventBus from "@/eventBus"

const catchForbiddenError = () => {
  // TODO: Implement 403 error screen
  eventBus.$emit('requestErrorCaptured', 404)
}

export default catchForbiddenError
